"use client";

import React, { useState } from "react";

import { useSelector } from "@/redux/hooks";

import { getState } from "../../redux/selectors/location";
import getAgeRequirementForState from "../../utils/getAgeRequirementsForState";
import Button from "../botanic/Button";
import { ActionRequiredModal } from "../botanic/Modal/ActionRequiredModal";
import AgeGateForm, { AgeGateChildFormProps } from "./AgeGateForm";
import AgeGateRememberMe from "./AgeGateRememberMe";
import AgeGateTermsAndPrivacy from "./AgeGateTermsAndPrivacy";

const UsAgeGateForm: React.FC<AgeGateChildFormProps> = ({
  confirm,
  rememberUser,
  setRememberUser,
}) => {
  const state = useSelector(getState);
  const age = getAgeRequirementForState("US", state);

  const [ageIsInvalid, setAgeIsInvalid] = useState(false);
  const decline = () => setAgeIsInvalid(true);

  return (
    <ActionRequiredModal
      aria-labelledby="age-gate-dialog-id"
      mobileFullscreen={false}
    >
      <div className="px-lg" data-testid="age-gate-modal-us">
        <AgeGateForm>
          <>
            <div
              id="age-gate-dialog-id"
              className="my-lg font-bold text-sm"
            >{`Are you ${age} or older?`}</div>
            <div className="flex flex-col md:flex-row gap-3">
              <Button
                data-testid="age-gate-no-button"
                variant="secondary"
                onClick={decline}
                className="max-w-[100%]"
              >
                not yet
              </Button>
              <Button
                onClick={confirm}
                className="max-w-[100%]"
                data-testid="age-gate-yes-button"
              >
                you bet!
              </Button>
            </div>
          </>
        </AgeGateForm>
        <AgeGateRememberMe
          rememberUser={rememberUser}
          setRememberUser={setRememberUser}
        />
        {ageIsInvalid && (
          <p className="mt-xl text-error" data-testid="age-gate-modal-invalid">
            Darn! You're not old enough to use Leafly.
          </p>
        )}
        <div className="mt-xxl py-lg border-t border-light-grey">
          <AgeGateTermsAndPrivacy />
        </div>
      </div>
    </ActionRequiredModal>
  );
};

export default UsAgeGateForm;
